"use strict";
exports.__esModule = true;
exports.RELINK = void 0;
exports.RELINK = {
    RENT_TRACKER: {
        HEADER: 'We couldn’t connect to your property',
        MAIN: 'This can happen if you moved, renewed your lease, or your property manager changed. Reconnect to your property by {{date}} to use Flex this month.',
        CTA: 'Reconnect property'
    },
    RENT_TRACKER_PORTAL: {
        HEADER: 'We couldn’t connect to your rent portal',
        MAIN: 'Update your rent portal connection by {{date}} to use Flex this month.',
        CTA: 'Update connection'
    },
    UPDATE_PORTAL: {
        HEADER: 'Update your portal connection',
        MAIN_ONE: 'Flex integrates with your property',
        MAIN_BOLD_ONE: '{{propertyName}} ',
        MAIN_TWO: 'through',
        MAIN_BOLD_TWO: '{{portalName}}',
        MAIN_THREE: '. Provide your most up-to-date login information to ensure Flex can pay rent on your behalf.',
        CTA: 'Connect'
    },
    HEADER: 'We couldn’t connect to your property',
    MAIN_TEXT_1: 'This can sometimes happen if you moved, renewed your lease, or your property manager changed.',
    BOLD_TEXT: 'Reconnect to your property by {{date}} to use Flex this month.',
    CTA: 'Reconnect property'
};
